<ng-container *ngIf="sectorOptions">
  <app-checkbox-filter
    [individualFilter]="individualFilter"
    [options]="sectorOptions"
    [pickedCheckboxes]="pickedSectorCheckboxes"
    [type]="type"
    [index]="index"
    [isMobile]="isMobile"
    [label]="getLabel"
    [noTranslate]="true"
    [isOpenBox]="isOpenBox"
    (filter)="applyCheckBoxFilter($event)">
  </app-checkbox-filter>
</ng-container>